export default "//file.bilionpass.com/japandx-portal/0.1.21/static/img/language-globe.01ddc0b2-a03264.svg";